<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <div class="row">
                <div class="col-12">
                    <ValidationProvider name="type" rules="" v-slot="{ errors }">
                        <b-form-group>
                            <b-form-radio-group v-model="form.type">
                                <b-form-radio value="payment">{{ $t('payment') }}</b-form-radio>
                                <b-form-radio value="refund">{{ $t('refund') }}</b-form-radio>
                            </b-form-radio-group>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider name="customer_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('customer')">
                            <customers-auto-complete v-model="form.customer_id" :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider name="subject" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('subject')">
                            <b-form-input v-model="form.subject" :readonly="form.type === 'refund'"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider name="amount" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('amount')">
                            <b-form-input v-model="form.amount" type="number"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider name="currency" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('currency')">
                            <currency-selectbox v-model="form.currency"></currency-selectbox>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider name="due_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('due_date')">
                            <select-date v-model="form.due_date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <!-- <div class="col-4">
                    <ValidationProvider name="paid_amount" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('amount_paid')">
                            <b-form-input v-model="form.paid_amount" type="number"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div> -->
                <!-- <div class="col-4">
                    <ValidationProvider name="flight_information" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('flight_information')">
                            <multi-selectbox v-model="form.flight_information"
                                             :multiple="false"
                                             :validate-error="errors[0]"
                                             :options="[{value:'Gerçekleşti', text:'Gerçekleşti'},{value:'Gerçekleşmedi', text:'Gerçekleşmedi'}]"></multi-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </div> -->
                <!-- <div class="col-4">
                    <ValidationProvider name="invoice_number" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('invoice_number')">
                            <b-form-input v-model="form.invoice_number"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider name="invoice_amount" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('invoice_amount')">
                            <b-form-input v-model="form.invoice_amount" type="number"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div> -->
                <div class="col-12">
                    <ValidationProvider name="file" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('file')">
                            <div class="d-flex custom-file-upload">
                                <b-form-file v-model="form.file"
                                             :state="errors[0] ? false : (valid ? true : null)"
                                             :placeholder="$t('select_file')"
                                             :drop-placeholder="$t('drop_file')"
                                             ref="fileInput"
                                />
                                <b-button variant="outline-secondary"
                                          @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                </b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </div>
            </div>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex">
            <b-button
                @click="createForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Component
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import PilotagePaymentsService from "@/services/PilotagePaymentsService";
    import CustomersAutoComplete from "@/components/interactive-fields/CustomersAutoComplete.vue";
    import CurrencySelectbox from "@/components/interactive-fields/CurrencySelectbox.vue";

    export default {
        components: {
            CurrencySelectbox,
            CustomersAutoComplete,
            ValidationProvider, ValidationObserver,
        },
        data() {
            return {
                formLoading: false,
                form: {
                    type: 'payment',
                    customer_id: null,
                    subject: null,
                    amount: null,
                    currency: null,
                    due_date: null,
                    // paid_amount: null,
                    // flight_information: null,
                    // invoice_number: null,
                    // invoice_amount: null
                }
            }
        },
        watch: {
            'form.type'(val) {
                if (val === 'refund') {
                    if (this.form.subject !== 'İade')
                    this.form.subject = this.$t('refund')
                } else if (val === 'payment') {
                    this.form.subject = null
                }
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.formLoading = true;

                    let formData = new FormData();
                    formData.append('customer_id', this.form.customer_id)
                    formData.append('subject', this.form.subject)
                    formData.append('amount', this.form.amount)
                    formData.append('currency', this.form.currency)
                    formData.append('due_date', this.form.due_date)

                    if(this.form.file) {
                        formData.append('file', this.form.file)
                    }

                    PilotagePaymentsService.store(formData)
                                    .then((response) => {
                                        this.$toast.success(this.$t("api." + response.data.message));
                                        this.$emit("createFormSuccess")
                                    })
                                    .catch((error) => {
                                        this.showErrors(error, this.$refs.formModalValidate)
                                    }).finally(() => {
                        this.formLoading = false;
                    });
                }
            }
        }
    }
</script>
